import React from 'react';
import { Select } from 'antd';

/**
 * Code type selector for invoice/quote items.
 * HSN Code = goods (maps to IsServc 'N'), SAC Code = services (maps to IsServc 'Y').
 * UOM is mandatory for HSN items and optional for SAC items.
 */
const CODE_TYPE_OPTIONS = [
  { value: 'HSN', label: 'HSN Code' },
  { value: 'SAC', label: 'SAC Code' }
];

const CodeTypeSelect = ({ value, onChange, style, ...props }) => {
  return (
    <Select
      style={{ width: '100%', ...style }}
      value={value || 'HSN'}
      onChange={onChange}
      options={CODE_TYPE_OPTIONS}
      getPopupContainer={(trigger) => trigger.parentNode}
      {...props}
    />
  );
};

// Derive code type from the GST service flag used across the app
export const codeTypeFromIsServc = (isServc) => (isServc === 'Y' ? 'SAC' : 'HSN');
export const isServcFromCodeType = (codeType) => (codeType === 'SAC' ? 'Y' : 'N');

export default CodeTypeSelect;
